// extracted by mini-css-extract-plugin
export default {"main":"err404_main__dehsh","spooky":"err404_spooky__Frydg"};